export default __webpack_public_path__ + "static/media/customer-journey-mapping.2b84e79b.svg";